import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives';
import { Text } from '@atlaskit/primitives/compiled';

export const i18n = defineMessages({
	abbreviatedReadTime: {
		id: 'quick-summary.abbreviated-estimated-read-time',
		defaultMessage: '{readTime} min',
		description: 'Abbreviated estimated time to read this page',
	},
});

const styles = cssMap({
	customTextDecorationLine: { textDecorationLine: 'line-through' },
});

type QuickSummarySaveTimeTextProps = {
	originalReadTime: number;
	summaryReadTime: number;
};

export const QuickSummarySaveTimeText = ({
	originalReadTime,
	summaryReadTime,
}: QuickSummarySaveTimeTextProps) => {
	const { formatMessage } = useIntl();

	const originalReadTimeText = formatMessage(i18n.abbreviatedReadTime, {
		readTime: originalReadTime,
	});

	const summaryReadTimeText = formatMessage(i18n.abbreviatedReadTime, {
		readTime: summaryReadTime,
	});

	return (
		<Inline space="space.100">
			<Text xcss={styles.customTextDecorationLine} color="color.text.subtlest">
				{originalReadTimeText}
			</Text>
			<Text color="color.text.subtlest">{summaryReadTimeText}</Text>
		</Inline>
	);
};
